import { fetchProjectsFx } from '.'

fetchProjectsFx()
setInterval(fetchProjectsFx, 5000)
